import { useState, useCallback, useRef, useEffect, useContext, Suspense } from "react";
import { DependentBenefitDetailsProps } from "../../../../../../../../../@types/components/memberDetailsProps.types";
import { Enrollment } from "../../../../../../../../../@types/enrollment.types";
import { ADMIN_DASHBOARD_HEADER } from "../../../../../../../../../constants/caption/dashboardHeader";
import { UIContext } from "../../../../../../../../../contexts";
import useRouteParam from "../../../../../../../../../hooks/useRouteParam";
import { api } from "../../../../../../../../../utils/api";
import { GetDependentBenefitsQuery } from "../../../../../../../../../utils/api/enrollment/enrollment";
import DependentBenefitGridDetails from "./dependentBenefitGridDetails/DependentBenefitGridDetails";

const DependentBenefitDetails = ({ dependent }: DependentBenefitDetailsProps): JSX.Element => {
	const [currentBenefitDetails, setCurrentBenefitDetails] = useState<Enrollment[]>([]);
	const [futureBenefitDetails, setFutureBenefitDetails] = useState<Enrollment[]>([]);
	const { setDashboardHeader } = useContext(UIContext);
	const queryGroupNumber = useRouteParam("gn");

	const getDependentBenefits = useCallback(async () => {
		if (dependent === undefined && (queryGroupNumber === null || queryGroupNumber === undefined)) {
			return;
		}
		const getDependentBenefitsQuery: GetDependentBenefitsQuery = {
			insured_SSN: dependent.employee_SSN,
			member_SSN: dependent.SSN,
			group_number: dependent.group_number as unknown as string
		};
		const dependentBenefits: Enrollment[] = await api.enrollments.getDependentBenefits(getDependentBenefitsQuery);
		const _currentDependentBenefits: Enrollment[] = [];
		const _futureDependentBenefoits: Enrollment[] = [];

		dependentBenefits.forEach((dependentBenefit: Enrollment) => {
			const { effective_date } = dependentBenefit;
			if (new Date() > new Date(effective_date as any)) {
				_currentDependentBenefits.push(dependentBenefit);
			} else {
				_futureDependentBenefoits.push(dependentBenefit);
			}
		});

		setCurrentBenefitDetails(Object.assign([], _currentDependentBenefits));
		setFutureBenefitDetails(Object.assign([], _futureDependentBenefoits));
	}, [dependent, queryGroupNumber]);

	useEffect(() => {
		getDependentBenefits();
		setDashboardHeader(ADMIN_DASHBOARD_HEADER.dependent_benefit_details);
	}, [getDependentBenefits, setDashboardHeader]);

	return (
		<div className="dependent-benefit-details-container">
			<div className="pf-title">Current Benefit</div>
			<DependentBenefitGridDetails gridData={currentBenefitDetails} benefitType="ACTIVE" />
			<div className="pf-title">Future Benefit</div>
			<DependentBenefitGridDetails gridData={futureBenefitDetails} benefitType="FUTURE" />
		</div>
	);
};

export default DependentBenefitDetails;
